import { Injectable } from '@angular/core';
import { FeathersAppService } from '@fire/feathers';
import { fireLogger } from '../utils/fire-logger';
import { FeathersConnectionNames } from '../config/feathers-connection-names';
import { AppConfig } from '../config/app.config';
import { ConfigService } from './config.service';


@Injectable()
export class AppService {


  constructor(
    private feathersAppService:FeathersAppService,
    private configService:ConfigService,
  ) {
  }


  /**
   * initialize app - db connections and the like
   *
   * @returns {Promise<boolean>}
   */
  initializeApp() {

    return Promise.resolve()
      .then(() => this.initFeathersConnectionToMain())
      .then(() => true);

  }




  //******************************************************************************************
  //******************************************************************************************
  //                                    CONNECTIONS



  /**
   * initialize the Feathers connection to the Striv360 SuperAppServer (for global login)
   * @returns {Promise<FeathersConnection>}
   */
  private initFeathersConnectionToMain() {

    fireLogger.log(`Feathers initializing "Main" connection: "${this.configService.organizationConfig.apiEndpoint}"`);

    return this.feathersAppService.createOrUpdateConnection(FeathersConnectionNames.Main, {
      apiEndpoint: this.configService.organizationConfig.apiEndpoint,
      storageType: 'localStorage',
      appName: AppConfig.pascalCaseName,
      timeout: 120000,
    });

  }



}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/services/app.service.ts